import {
  FormControl,
  FormControlProps,
  InputLabel,
  MenuItem,
  Select,
  SelectProps,
} from "@mui/material";
import { useBoundStore } from "../../../store/store";
import { meetingTypeLabel } from "../../../model/meeting_type";

export interface MeetingTypeInfoSelectProps {
  currentMeetingTypeId?: string;
  onMeetingTypeChange: (meetingTypeId: string) => void;
  includeAllOption?: boolean;
  formControlProps?: FormControlProps;
  selectProps?: SelectProps;
}

export const MeetingTypeInfoSelect = (props: MeetingTypeInfoSelectProps) => {
  const { currentMeetingTypeId, onMeetingTypeChange, formControlProps, selectProps } =
    props;
  const meetingTypes = useBoundStore((state) => state.meetingTypes);

  return (
    <FormControl {...formControlProps}>
      <InputLabel>Meeting Type</InputLabel>
      <Select
        {...selectProps}
        label="Meeting Type"
        value={currentMeetingTypeId}
        onChange={(e) => {
          onMeetingTypeChange(e.target.value as string);
        }}
      >
        {
          /* If includeAllOption is true, add an "All" option */
          props.includeAllOption && (
            <MenuItem key="all" value="All">
              All
            </MenuItem>
          )
        }
        {
          /* Map through the meeting types and create MenuItem for each */
          meetingTypes.map((meetingType) => (
            <MenuItem key={meetingType.id} value={meetingType.id}>
              {meetingTypeLabel(meetingType)}
            </MenuItem>
          ))
        }
      </Select>
    </FormControl>
  );
};
